export default __webpack_public_path__ + "static/1285-e16f45a182ca2a88df9a1bd12c0406c5.gif";